import React, { Component } from 'react';

import ActionBar from './ActionBar/ActionBar'
import EoTResult from './EoT/EoTResult'
import LineBreakResult from './LineBreakResult'
import MessageResult from './MessageResult'
import WarhammerResult from './Warhammer/WarhammerResult';

class RollResults extends Component {
  constructor() {
    super();
    this.state = {
      selectedItems: {},
      doClear: false
    }
  }

  onToggle(isSelected, result) {
    // Dirty clone
    var newState = JSON.parse(JSON.stringify(this.state.selectedItems));

    if (isSelected) {
      newState[result.key] = result;
    } else {
      delete (newState[result.key]);
    }
    this.setState({
      selectedItems: newState,
      doClear: false
    })
  }

  showActionBar() {
    return Object.keys(this.state.selectedItems).length > 0;
  }

  clearToggles() {
    this.setState({
      selectedItems: {},
      doClear: true
    })
  }

  render() {
    return (
      <div className="RollResults">
        {this.showActionBar() ? <ActionBar items={this.state.selectedItems} onClearToggle={this.clearToggles.bind(this)} /> : ''}
        {this.props.resultList.map(result => {
          switch(result.type) {
            case 'MESSAGE':
              return <MessageResult key={result.key} result={result} />
            case 'LINEBREAK':
              return <LineBreakResult key={result.key} result={result} />
            case 'ROLL.WARHAMMER':
              return <WarhammerResult key={result.key} result={result} />
            case 'ROLL.EOT':
            default: // legacy before supporting roll types
              return <EoTResult key={result.key} result={result} forceToggleClear={this.state.doClear} toggleCallback={this.onToggle.bind(this)} />
          }
        })
        }
      </div>
    )
  }
}

export default RollResults




// WEBPACK FOOTER //
// ./src/RollResults/index.js